module.exports = __webpack_public_path__ + "img/whatsapp-verde.81f7b335.png";